// api/axios.js (o donde tengas este archivo)
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || '/api',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // ✅ NUEVO: Manejo global de sesión expirada (401)
    if (error.response && error.response.status === 401) {
      console.warn("⚠️ Sesión expirada o token inválido. Redirigiendo al inicio...");
      
      // 1. Limpiar todo lo relacionado a la sesión
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      localStorage.removeItem('user_uuid');
      
      // 2. Redirigir al Home (usamos window.location para forzar una recarga limpia)
      window.location.href = '/';
      
      return Promise.reject(error);
    }

    // Lógica de reintento original (si la necesitas)
    const config = error.config;
    if (!config || !config.retry) return Promise.reject(error);
    config.retryCount = config.retryCount || 0;
    if (config.retryCount >= config.retry) return Promise.reject(error);
    
    config.retryCount += 1;
    await new Promise((resolve) => setTimeout(resolve, 1000)); // 1 segundo de espera
    return api(config);
  }
);

export default api;